import e from "../../hooks/useResizeObserver.js";
import t from "../../hooks/useClickOutside.js";
import n from "../../utils/classNames.js";
import r from "./CollapsedNavItem.js";
import { useLayoutEffect as i, useRef as a, useState as o } from "react";
import { isEmpty as s } from "es-toolkit/compat";
import { jsx as c } from "react/jsx-runtime";
//#region src/components/applicationHeader/NavItems.tsx
var l = 50, u = 15, d = [], f = [], p = (p) => {
	let { navItems: m = d, actionBarItems: h = f, containerWidth: g } = p, [_, v] = o(!1), [y, b] = o([]), [x, S] = o([]), [C, w] = o(!0), T = t(() => v(!1)), [E, , { inlineSize: D }] = e(), O = a(null), k = a(1), A = () => {
		O.current !== null && (window.cancelAnimationFrame(O.current), O.current = null);
	};
	i(() => {
		A(), k.current = 1, w(!0);
	}, [
		m,
		h,
		g,
		D
	]), i(() => () => A(), []), i(() => {
		C && (M(), k.current > 0 && (--k.current, O.current = window.requestAnimationFrame(() => {
			O.current = null, w(!0);
		})));
	});
	let j = (e) => e.clientWidth - l - u, M = () => {
		let e = E.current;
		if (!e) {
			w(!1);
			return;
		}
		let t = [...e.children || []], n = j(e);
		if (n < 0) {
			S([]), b(m), w(!1);
			return;
		}
		let r = 0, i = [], a = [];
		t.forEach((e) => {
			if (!e.className) return;
			r += e.scrollWidth;
			let t = m.find((t) => {
				let n = e.attributes.getNamedItem("data-nav-item-key");
				return n && t.key === n.value;
			});
			t && (n > r ? i.push(t) : a.push(t));
		}), S(i), b(a), w(!1);
	}, N = () => {
		v(!_);
	}, P = () => {
		_ && v(!1);
	}, F = (e, t) => /* @__PURE__ */ c("li", {
		className: `submodule ${t ? "offscreen" : ""}`,
		"data-nav-item-key": e.key,
		children: e.route
	}, e.key), I = () => !C && !s(y) ? [...x.map((e) => F(e, C)), /* @__PURE__ */ c(r, {
		ref: T,
		show: _,
		navItems: y,
		actionBarItems: h,
		onDropdownClick: N,
		onItemClick: P
	}, "CollapsedNavItem")] : m.map((e) => F(e, C)), L = n("SubmoduleNavigation", "nav");
	return /* @__PURE__ */ c("ul", {
		className: L,
		ref: E,
		children: I()
	});
};
//#endregion
export { p as NavItems, p as default };

//# sourceMappingURL=NavItems.js.map